import React, { useContext, useEffect, useState } from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import { AppRelevantDataContext } from '../../AppContext';
import App from '../../App';
import '@studysync/react-splitter-layout/lib/index.css';
import  VcMaps from './VcMaps';
import VcSideNav from './DeviceHome/VcSideNav';
import { GrMenu } from 'react-icons/gr';
import vilisoLogoTransparent from './../IMAGES/vilisoLogoTransparent.png'
import { FaArrowAltCircleLeft, FaWindowClose } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { clearDeviceList } from './Store/Slices/deviceList';
import { clearTreeNodeList } from './Store/Slices/treeNodeList';
import VcMapsTrackDevice from './VcMapsTrackDevice';
import { setToSearchDeviceIDOnMap } from './Store/Slices/variables';
import { RiMenuUnfoldLine } from 'react-icons/ri';
import VcMapLayout from './MapHome/VcMapLayout';
import axios from 'axios';
import { getAPIHostURL } from '../../ClientConfig';
import { IDS_LoginServerIssue, IDS_RegistNetworkError } from '../../VcLanguage';

function VcMapPg (props) {

  const context = useContext(AppRelevantDataContext);
  const navigate = useNavigate();
  const location = useLocation(); 
  const dispatch = useDispatch();

  const deviceIdToSearch = useSelector(s => s.variables.toSearchDeviceIDOnMap)
  const [state, setState] = useState({
    showDrawer: false,
    others: {errors: ''} // For showing any other error messages that are not specific to any input field (like network error, server error etc.)
  })

  const [filters, setFilters] = useState({
    state: null,
    territory: null,
    district: null,
    city: null,
    pincode: null,
  });

  const [locationData, setLocationData] = useState({});
  const [territoryList, setTerritoryList] = useState([]);

  const [options, setOptions] = useState({
    state: [],
    district: [],
    city: [],
    pincode: [],
    territory: []
  });

  const [maps, setMaps] = useState({
    cityToDistrict: {},
    districtToState: {},
    pincodeToCity: {}
  });

  const [getBPCLToilet, setGetBPCLToilet] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const isMapLayout = window.location.pathname === "/mapsLayout";
   
  // useEffect(() => {

  //   let appRelevantDataContextValue = context; // Get all the relevant data from AppContext

  //   if( appRelevantDataContextValue.loggedInUserInfo.userFirstName.length <= 0 ) {
  //     // User login information is not present in appRelevantDataContext.
  //     // Try to get this value if present in LocalStorage and update the app state (so that
  //     // re-render will happen). If app context data not present in LocalStorage then
  //     // show the Login Page
  //     if ( appRelevantDataContextValue.updateAppRelevantDataContextFromLocalStorage() == false ) {
  //       // App Relevant Data Context not present in LocalStorage as well.
  //       navigate('/');
  //     } else {
  //       // App Relevant Data Context loaded from LocalStorage at AppLeval.
  //       // Re-render will happen automatically (no action required).
  //     }

  //   }

  //   dispatch(clearTreeNodeList())
  //   dispatch(clearDeviceList())

  //   getLocationFilterDropdownData();
    
  //   return () => {
  //     dispatch(setToSearchDeviceIDOnMap(''))
  //     // toSearchDeviceIDOnMap
  //   }
  // }, [])

  useEffect(() => {

    let appRelevantDataContextValue = context;

    /*
      For authenticated users:
      - Restore session from localStorage if context is empty.

      For guest users opening /maps from login page:
      - Allow access even if no login/session exists.
      - Do NOT redirect to "/".
    */
    if (appRelevantDataContextValue.loggedInUserInfo.userFirstName.length <= 0) {

      const contextLoaded = appRelevantDataContextValue.updateAppRelevantDataContextFromLocalStorage();

      if (!contextLoaded) {
        console.log("Guest user opening maps without login");
        // intentionally no navigate('/')
      }
    }

    // Clear previous map/tree data
    dispatch(clearTreeNodeList());
    dispatch(clearDeviceList());

    if(location.pathname === "/mapsLayout") {
      // Load map dropdown/filter data
      getLocationFilterDropdownData();
    }

    return () => {
      dispatch(setToSearchDeviceIDOnMap(''));
    };

  }, [location.pathname, getBPCLToilet]); 

  useEffect(() => {
      const handleResize = () => {
          setWindowWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
      window.removeEventListener('resize', handleResize);
      };
  }, []);

  const updateOptions = (filters) => {

    let { state, district, city } = filters;

    let districts = [];
    let cities = [];
    let pincodes = [];

    if (state) {
      districts = Object.keys(locationData[state] || {});
    } else {
      districts = Object.values(locationData).flatMap(d => Object.keys(d));
    }

    districts.forEach(d => {
      let s = state || maps.districtToState[d];

      Object.entries(locationData[s][d] || {}).forEach(([c, pins]) => {
        cities.push(c);
        pincodes.push(...pins);
      });
    });

    if (district) {
      let s = maps.districtToState[district];
      cities = Object.keys(locationData[s][district] || {});
      pincodes = [];

      cities.forEach(c => {
        pincodes.push(...locationData[s][district][c]);
      });
    }

    if (city) {
      let d = maps.cityToDistrict[city];
      let s = maps.districtToState[d];

      pincodes = locationData[s][d][city] || [];
    }

    const uniqueSorted = (arr) => [...new Set(arr)].sort();

    setOptions(prev => ({
      ...prev,
      district: uniqueSorted(districts).map(v => ({ label: v, value: v })),
      city: uniqueSorted(cities).map(v => ({ label: v, value: v })),
      pincode: uniqueSorted(pincodes).map(v => ({ label: v, value: v }))
    }));
  };

  useEffect(() => {
    if (!locationData || Object.keys(locationData).length === 0) return;

    let districts = [];
    let cities = [];
    let pincodes = [];

    if (filters.state) {
      // STATE SELECTED
      const stateData = locationData[filters.state] || {};

      Object.entries(stateData).forEach(([district, citiesObj]) => {
        districts.push(district);

        Object.entries(citiesObj).forEach(([city, pins]) => {
          cities.push(city);
          pincodes.push(...pins);
        });
      });

    } else if (filters.district) {
      // DISTRICT SELECTED
      const state = maps.districtToState[filters.district];
      const districtData = locationData[state]?.[filters.district] || {};

      Object.entries(districtData).forEach(([city, pins]) => {
        cities.push(city);
        pincodes.push(...pins);
      });

    } else if (filters.city) {
      // CITY SELECTED
      const district = maps.cityToDistrict[filters.city];
      const state = maps.districtToState[district];
      const cityPins = locationData[state]?.[district]?.[filters.city] || [];

      pincodes = cityPins;
    }

    const unique = (arr) => [...new Set(arr)];

    updateOptions(filters);
    setOptions(prev => ({
      ...prev,
      district: filters.state
        ? unique(districts).map(v => ({ label: v, value: v }))
        : prev.district,

      city: (filters.state || filters.district)
        ? unique(cities).map(v => ({ label: v, value: v }))
        : prev.city,

      pincode: (filters.state || filters.district || filters.city)
        ? unique(pincodes).map(v => ({ label: v, value: v }))
        : prev.pincode
    }));

  }, [filters, locationData]);

      
  const buildMappings = (data) => {

    let cityToDistrict = {};
    let districtToState = {};
    let pincodeToCity = {};

    Object.entries(data).forEach(([state, districts]) => {

      Object.entries(districts).forEach(([district, cities]) => {

        districtToState[district] = state;

        Object.entries(cities).forEach(([city, pincodes]) => {

          cityToDistrict[city] = district;

          pincodes.forEach(p => {
            pincodeToCity[p] = city;
          });

        });
      });
    });

    setMaps({ cityToDistrict, districtToState, pincodeToCity });
  };                              

  const formatLabel = (str) => str ? str.charAt(0) + str.slice(1).toLowerCase() : str;

  const fillAllDropdowns = (data, territories) => {

    let states = Object.keys(data);
    let districts = [];
    let cities = [];
    let pincodes = [];

    Object.values(data).forEach(districtsObj => {
      Object.entries(districtsObj).forEach(([district, citiesObj]) => {

        districts.push(district);

        Object.entries(citiesObj).forEach(([city, pins]) => {
          cities.push(city);
          pincodes.push(...pins);
        });

      });
    });

    const uniqueSorted = (arr) => [...new Set(arr)].sort();

    setOptions({
      state: uniqueSorted(states).map(v => ({ label: v, value: v })),
      district: uniqueSorted(districts).map(v => ({ label: v, value: v })),
      city: uniqueSorted(cities).map(v => ({ label: v, value: v })),
      pincode: uniqueSorted(pincodes).map(v => ({ label: v, value: v })),
      territory: uniqueSorted(territories).map(v => ({ label: v, value: v }))
    });
  };

  const getLocationFilterDropdownData = () => {
  
      let appRelevantDataContextValue = context;
      let t = appRelevantDataContextValue.t;
  
      let modifiedState = state;
      
      let jsonBody = {
        OrgName: getBPCLToilet ? "BPCL" : ""
      };

      axios.post( `${getAPIHostURL()}/wclient/getLocationFilterDropdownData`, jsonBody)
      .then(response => {
  
        if(response.data.code == 'SUCCESS') {
  
          let dropDownOptions = response.data.dropDownOptions;
  
          if( dropDownOptions == null || dropDownOptions.length <= 0 ) {
              // modifiedState.errors.others = t(IDS_MapStandard);
          } else {
  
            const data = dropDownOptions.location;
            const territories = dropDownOptions.territory || [];

            setLocationData(data);
            setTerritoryList(territories);

            buildMappings(data);
            fillAllDropdowns(data, territories);

          }
          
        } else {
            if(response.data.code == 'SQL_ERROR') {
              // Tell the user that Server is experiencing errors
              modifiedState.errors.others = t(IDS_LoginServerIssue);
  
            } else {
              console.log('Should not reach here');
              modifiedState.errors.others = t(IDS_LoginServerIssue);
  
          }
          // Display the specific error message for login failure
        }
        setState({...modifiedState});
      })
      .catch( error => {
        console.log("Network error:");
        console.log(error);
        if (axios.isCancel(error)) {
          console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
        } else {
          // Tell the user that there are network issues
          modifiedState.errors.others = t(IDS_RegistNetworkError);
          setState({...modifiedState});
        }
      });
    }
  
    let appRelevantDataContextValue = context;  // Get all the relevant data from AppContext
    let isGuestUser = false;
    if( appRelevantDataContextValue.loggedInUserInfo.userFirstName.length <= 0 ) {
      // User login information is not present in appRelevantDataContext.

      // Next re-render will happen automatically when the AppState is updated again 
      // from LS in ComponentDidMount, (meanwhile 'Loading Page' shown)
      // return App.renderLoadingPage();

      isGuestUser = !appRelevantDataContextValue?.loggedInUserInfo?.userFirstName;
    }

       if(windowWidth < 550) {
        return  <>  
          {!isGuestUser &&
          <div  className={`drawerDiv ${state.showDrawer ? 'drawerDivIn' : 'drawerDivOut'}`}>
              <VcSideNav />
              <FaArrowAltCircleLeft 
                  className="closingArrow top-nav" onClick={()=> setState({...state , showDrawer : false})}
              />
          </div>}
          <div className='bg-white shadow flex items-center justify-between px-2 py-1 m-1 ' style={{position:"sticky", top:"0", borderRadius:"0.75rem"}}>
              <div className='' style={{width:"60px"}}>
                <img src={vilisoLogoTransparent} alt="" style={{maxWidth:"100%"}} />
              </div>
              {/* <FaWindowClose onClick={()=> setState({...state , showDrawer : !state.showDrawer})}/> */}
              {state.showDrawer ? 
              <MdClose classname='transition-all' onClick={()=> setState({...state , showDrawer : false})}/>:
              <span onClick={()=> setState({...state , showDrawer : true})}><RiMenuUnfoldLine style={{ fontSize: "1.2rem" }} /></span> 
              }
          </div>
            {/* {(deviceIdToSearch && deviceIdToSearch.length > 0) ?
              <VcMapsTrackDevice invokedFrom = "VcMapPg" DeviceID={deviceIdToSearch} />
            :x<VcMaps invokedFrom = "VcMapPg"/>                  
            } */}
            {(deviceIdToSearch && deviceIdToSearch.length > 0) ? (
                <VcMapsTrackDevice invokedFrom={"trackDevice"} DeviceID={deviceIdToSearch} />
              ) : (
                isMapLayout ? (
                <>
                  <VcMapLayout
                    filters={filters}
                    setFilters={setFilters}
                    options={options}
                    maps={maps}
                    getBPCLToilet={getBPCLToilet}
                    setGetBPCLToilet={setGetBPCLToilet}
                    getLocationFilterDropdownData={getLocationFilterDropdownData}
                  />
                </>
              ) : (
                <VcMaps
                  invokedFrom={props.invokedFrom}
                  filters={filters}
                  getBPCLToilet={getBPCLToilet}
                  setGetBPCLToilet={setGetBPCLToilet}
                  getLocationFilterDropdownData={getLocationFilterDropdownData}
                />
              )
              )}
                        
          </>
       } 
        return (
          <div className='w-100 d-flex relative'>
              {!isGuestUser &&
                <div style={{width:"4%", position:"relative", zIndex:"5"}}>
                    <VcSideNav/>
                </div>
              }
              <div style={{width: !isGuestUser ? "96%" : "100%" }}>
              {/* {(deviceIdToSearch && deviceIdToSearch.length > 0) ?
              <VcMapsTrackDevice invokedFrom = "VcMapPg" DeviceID={deviceIdToSearch} />
            :<VcMaps invokedFrom = "VcMapPg"/>                  
            } */}
            {(deviceIdToSearch && deviceIdToSearch.length > 0) ? (
                <VcMapsTrackDevice invokedFrom={"trackDevice"} DeviceID={deviceIdToSearch} />
              ) : (
                isMapLayout ? (
                <>
                  <VcMapLayout
                    filters={filters}
                    setFilters={setFilters}
                    options={options}
                    maps={maps}
                    getBPCLToilet={getBPCLToilet}
                    setGetBPCLToilet={setGetBPCLToilet}
                    getLocationFilterDropdownData={getLocationFilterDropdownData}
                  />
                </>
              ) : (
                <VcMaps
                  invokedFrom={props.invokedFrom}
                  filters={filters}
                  getBPCLToilet={getBPCLToilet}
                  setGetBPCLToilet={setGetBPCLToilet}
                  getLocationFilterDropdownData={getLocationFilterDropdownData}
                />
              )
              )}
              </div>
          </div>
        )
}

export default VcMapPg;

